export interface Deleted<K extends number | string> {
    id: K;
    deleted: true;
}

// @typescript-to-gdscript-gd-impl
export type MaybeDeleted<
    T,
    I extends string | number = T extends { id: string | number } ? T['id'] : never
> = T | Deleted<I>;

export function isDeleted<T extends object, K extends number | string>(
    value: Deleted<K> | T
): value is Deleted<K> {
    return value && 'deleted' in value;
}

export function notDeleted<T extends object>(
    value: Deleted<number | string> | Exclude<T, Deleted<number | string>>
): value is Exclude<T, Deleted<number | string>> {
    return !value || !('deleted' in value);
}
